import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { getElementsForAnimation } from './getElementsForAnimation';

gsap.registerPlugin(ScrollTrigger, SplitText);

export function splitTextAnimations(container = document) {
  let ctx;
  let isDestroyed = false;

  const init = () => {
    if (isDestroyed) return;

    ctx = gsap.context(() => {
      const elements = getElementsForAnimation(container, '.iv-from-blur');
      if (!elements?.length) return;

      elements.forEach((el) => {
        new SplitText(el, {
          type: 'lines',
          linesClass: 'blur-line',
          autoSplit: true,
          onSplit(instance) {
            gsap.fromTo(
              instance.lines,
              {
                y: 80,
                autoAlpha: 0,
                filter: 'blur(20px)'
              },
              {
                y: 0,
                autoAlpha: 1,
                filter: 'blur(0px)',
                duration: 1.2,
                ease: 'power2.out',
                stagger: 0.18,
                clearProps: 'transform,filter',
                scrollTrigger: {
                  trigger: el,
                  start: 'top 90%',
                  once: true
                }
              }
            );
          }
        });
      });
    }, container);

    ScrollTrigger.refresh();
  };

  if (document.fonts?.ready) {
    document.fonts.ready.then(init);
  } else {
    init();
  }

  return {
    destroy() {
      if (ctx) ctx.revert();
      isDestroyed = true;
    }
  };
}
